var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3473 5.2405H2.36629L6.24826 1.10669C6.50294 0.853684 6.50294 0.443428 6.24826 0.189754C5.99275 -0.0632513 5.57949 -0.0632513 5.32481 0.189754L0 5.9026L5.24309 11.6552C5.37077 11.7819 5.53754 11.8454 5.70482 11.8454C5.8716 11.8454 6.03887 11.7819 6.16655 11.6552C6.42122 11.4017 6.42122 10.9919 6.16655 10.7384L2.32434 6.53695H15.3473C15.7074 6.53695 16 6.24668 16 5.88873C16 5.53077 15.7074 5.2405 15.3473 5.2405Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.da9e3ab0d26698f3bc57ebd89b7458fe.svg";
export { ForwardRef as ReactComponent };